var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"tableSelection",attrs:{"border":"","columns":_vm.columns4,"data":_vm.data1},on:{"on-selection-change":_vm.submitSelection}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }